import React, {useEffect, useRef, useState} from 'react';
import BookList from "../bookList/BookList";
import useBookListStore from "../../store/bookListStore";
import {useSearchParams} from "react-router-dom";

interface IBookListState {
    limit?:number | null
    offset?:number | null
    search?:string | null
    keyWords?:string | null
    author?:string | null
    place?:string | null
    yearFrom?:number | null
    yearTo?:number | null
    year?:number | null
    type?:number | null
    subType?:number | null
}

const MainBookList = () => {
    const controllerRef = useRef<AbortController | null>(null);
    const {books,isLoading,error,totalCount} = useBookListStore(state => state);
    const getBooks = useBookListStore(state => state.getBooksPreview);
    const [searchParams, setSearchParams] = useSearchParams();

    const [localState,setLocalState] = useState<IBookListState>(() => ({
        limit:searchParams.has('limit') ? Number(searchParams.get('limit')) : 5,
        offset:searchParams.has('offset') ? Number(searchParams.get('offset')) : 0,
        search:searchParams.has('search') ? searchParams.get('search') : null,
        keyWords:searchParams.has('idKeyWords') ? searchParams.get('idKeyWords') : null,
        author:searchParams.has('author') ? searchParams.get('author') : null,
        place:searchParams.has('place') ? searchParams.get('place') : null,
        yearFrom:searchParams.has('yearFrom') ? Number(searchParams.get('yearFrom')) : null,
        yearTo:searchParams.has('yearTo') ? Number(searchParams.get('yearTo')) : null,
        year:searchParams.has('year') ? Number(searchParams.get('year')) : null,
        type:searchParams.has('type') ? Number(searchParams.get('type')) : null,
        subType:searchParams.has('subType') ? Number(searchParams.get('subType')) : null
    }));

    useEffect(() => {
        const newState: IBookListState = {
            limit:searchParams.has('limit') ? Number(searchParams.get('limit')) : 5,
            offset:searchParams.has('offset') ? Number(searchParams.get('offset')) : 0,
            search:searchParams.has('search') ? searchParams.get('search') : null,
            keyWords:searchParams.has('idKeyWords') ? searchParams.get('idKeyWords') : null,
            author:searchParams.has('author') ? searchParams.get('author') : null,
            place:searchParams.has('place') ? searchParams.get('place') : null,
            yearFrom:searchParams.has('yearFrom') ? Number(searchParams.get('yearFrom')) : null,
            yearTo:searchParams.has('yearTo') ? Number(searchParams.get('yearTo')) : null,
            year:searchParams.has('year') ? Number(searchParams.get('year')) : null,
            type:searchParams.has('type') ? Number(searchParams.get('type')) : null,
            subType:searchParams.has('subType') ? Number(searchParams.get('subType')) : null
        };

        let changed = false;
        for (const key of Object.keys(newState) as (keyof IBookListState)[]) {
            if (newState[key] !== localState[key]) {
                changed = true;
                break;
            }
        }
        if (changed) {
            setLocalState(newState);
        }
    }, [searchParams]);

    useEffect(()=>{
        if (controllerRef.current) {
            controllerRef.current.abort();
        }
        const abortController = new AbortController();
        controllerRef.current = abortController;
        getBooks(
            localState.offset, localState.limit, localState.search, localState.keyWords,
            localState.author, localState.place, localState.yearFrom, localState.yearTo,
            localState.year, localState.type, localState.subType, abortController.signal
        );

        return () => abortController.abort();
    }, [localState]);

    return (
        <div>
            <BookList books={books} isLoading={isLoading} error={error} totalCount={totalCount} />
        </div>
    );
};

export default MainBookList;